/**
 * Switches the page cursor to signal a long-running operation. Sets the document body cursor to progress while loading and back to auto otherwise.
 *
 * @param isLoading - Whether an operation is currently in flight.
 * @returns Nothing.
 */
const toggleLoadingCursor = (isLoading: boolean) => {
  if (isLoading) {
    document.body.style.cursor = 'progress';
  } else {
    document.body.style.cursor = 'auto';
  }
};

export default toggleLoadingCursor;
